<app-carrier-work-orders
  identityScope="customer"
  pageTitle="Customer Work Orders"
  scopeLabel="Customer Scope"
  scopeNoun="customer"
  [scopeProfileType]="2"
  detailsRoute="/customer_order_details"
></app-carrier-work-orders>
